/**
 * English: Poll GET /api/status/{task_id} for task state snapshots.
 * Thai: poll GET /api/status/{task_id} เพื่อ snapshot state ของงาน
 */
import { useState, useCallback } from 'react';
import { useApi } from './useApi';
import { ENDPOINTS } from '../config/api';
import { TaskState } from '../types';

interface UseTaskStatusResult {
  taskState: TaskState | null;
  loading: boolean;
  error: string | null;
  fetchStatus: (taskId: string) => Promise<TaskState | null>;
}

export function useTaskStatus(): UseTaskStatusResult {
  const { get } = useApi();
  const [taskState, setTaskState] = useState<TaskState | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStatus = useCallback(async (taskId: string): Promise<TaskState | null> => {
    setLoading(true);
    setError(null);
    try {
      const data = await get(ENDPOINTS.status(taskId)) as TaskState;
      setTaskState(data);
      return data;
    } catch (err) {
      setError((err as Error).message);
      setTaskState(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [get]);

  return { taskState, loading, error, fetchStatus };
}
